import { PageHeader, Tag, message, Alert, Typography, Select, Tooltip, Row, Col } from "antd";
import { PoweroffOutlined, LogoutOutlined, ReloadOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ButtonItem,
  SelectItem,
  TableItemDinamico,
} from "../../../Components/Items";
import ModalCerrarSesiones from "./ModalCerrarSesiones/ModalCerrarSesiones";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const { Text } = Typography;
const { Option } = Select;

class Sesiones extends Component {
  state = {
    loading: false,
    sesiones: [],
    totalRecords: 0,

    // Filtro por empresa
    objetoEmpresas: null,
    empresaSeleccionada: undefined,

    // Modal cerrar sesión(es)
    modalCerrarVisible: false,
    tipoCerrar: "una", // 'una' | 'todas'
    sesionACerrar: null,
  };

  ultimosParams = {};

  componentDidMount() {
    this.consultarEmpresas();
  }

  consultarEmpresas() {
    axios
      .post("sesiones/selectEmpresasSesiones", {}, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            objetoEmpresas: (res.data.empresas || []).map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre || "Sin nombre"}
              </Option>
            )),
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  seleccionarEmpresa = (empresaId) => {
    this.setState({ empresaSeleccionada: empresaId });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ empresaId: empresaId || undefined });
    }
  };

  consultarSesiones(params = {}) {
    this.ultimosParams = params;
    this.setState({ loading: true });

    axios
      .post("sesiones/selectSesiones", { ...params }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            sesiones: res.data.data || [],
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({ sesiones: [], totalRecords: 0, loading: false });
          if (res.data.success === 1) {
            message.error("Este usuario no tiene acceso a las sesiones");
          } else {
            message.error(res.data.message || "Error al obtener las sesiones");
          }
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ sesiones: [], totalRecords: 0, loading: false });
        message.error("Este usuario no tiene acceso a las sesiones");
      });
  }

  refrescar = () => {
    this.consultarSesiones(this.ultimosParams);
    this.consultarEmpresas();
  };

  // ----- Modal cerrar sesión(es) -----
  abrirModalCerrar = (sessionId) => {
    this.setState({
      modalCerrarVisible: true,
      tipoCerrar: "una",
      sesionACerrar: sessionId,
    });
  };

  abrirModalCerrarTodas = () => {
    this.setState({
      modalCerrarVisible: true,
      tipoCerrar: "todas",
      sesionACerrar: null,
    });
  };

  cerrarModalCerrar = () => {
    this.setState({ modalCerrarVisible: false, sesionACerrar: null });
  };

  handleCerrarSuccess = () => {
    this.cerrarModalCerrar();
    this.refrescar();
  };

  render() {
    const columns = [
      {
        title: "Usuario",
        dataIndex: "nombreUsuario",
        key: "nombreUsuario",
        sorter: true,
        buscar: "nombreUsuario",
      },
      {
        title: "Nombre completo",
        dataIndex: "nombreCompleto",
        key: "nombreCompleto",
      },
      {
        title: "Empresa",
        dataIndex: "empresaNombre",
        key: "empresaNombre",
        sorter: true,
        buscar: "empresaNombre",
      },
      {
        title: "Tipo",
        dataIndex: "tipo",
        key: "tipo",
        width: 110,
        align: "center",
        render: (tipo) =>
          tipo === 0 ? (
            <Tag color="geekblue">Principal</Tag>
          ) : tipo === 1 ? (
            <Tag color="purple">Subusuario</Tag>
          ) : (
            "—"
          ),
      },
      {
        title: "Tiempo restante",
        dataIndex: "expires",
        key: "expires",
        sorter: true,
        align: "center",
        render: (expires) => {
          if (!expires) return "—";
          const exp = moment(expires);
          if (!exp.isValid()) return "—";
          const restante = exp.diff(moment());
          const texto =
            restante > 0
              ? moment.duration(restante).humanize()
              : "Expirada";
          return (
            <Tooltip title={exp.format("LLL")}>
              <span style={{ color: restante > 0 ? undefined : "#ff4d4f" }}>
                {texto}
              </span>
            </Tooltip>
          );
        },
      },
      {
        title: "Última actividad",
        dataIndex: "ultimaActividad",
        key: "ultimaActividad",
        align: "center",
        render: (ultimaActividad) => {
          if (!ultimaActividad) return "—";
          const ult = moment(ultimaActividad);
          if (!ult.isValid()) return "—";
          return (
            <Tooltip title={ult.format("LLL")}>{ult.fromNow()}</Tooltip>
          );
        },
      },
      {
        title: "Acciones",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "20%",
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: "center", padding: "4px" },
        }),
        render: (_, record) => {
          if (record.esActual) {
            return <Tag color="green">Sesión actual</Tag>;
          }
          return (
            <div className="acciones-container">
              <ButtonItem
                type="primary"
                size="small"
                danger
                icon={<LogoutOutlined />}
                onClick={() => this.abrirModalCerrar(record._id)}
              >
                Cerrar
              </ButtonItem>
            </div>
          );
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Sesiones Activas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: "flex", gap: "8px" }}>
              <ButtonItem
                blanco
                icon={<ReloadOutlined />}
                onClick={this.refrescar}
              >
                Volver a consultar
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                icon={<PoweroffOutlined />}
                onClick={this.abrirModalCerrarTodas}
              >
                Cerrar todas las sesiones
              </ButtonItem>
            </div>
          }
        />

        <div
          style={{
            backgroundColor: "white",
            padding: 20,
            minHeight: "calc(100vh - 160px)",
            borderRadius: 12,
          }}
        >
          <Row gutter={16} align="stretch" style={{ marginBottom: 20 }}>
            <Col xs={24} md={8} lg={6}>
              <div
                style={{
                  height: "100%",
                  background:
                    "linear-gradient(120deg,  #66cee6af 0%, #ffffff 100%)",
                  borderRadius: 16,
                  padding: "24px",
                  textAlign: "center",
                  color: "#0A3D4A",
                  boxShadow: "0 4px 14px rgba(0, 131, 176, 0.15)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    letterSpacing: 1,
                    textTransform: "uppercase",
                    opacity: 0.85,
                    marginBottom: 4,
                  }}
                >
                  Sesiones activas
                </div>
                <div style={{ fontSize: 56, fontWeight: 800, lineHeight: 1 }}>
                  {this.state.totalRecords}
                </div>
              </div>
            </Col>

            <Col xs={24} md={16} lg={18}>
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <Alert
                  type="info"
                  showIcon
                  style={{ margin: 0 }}
                  message="Las sesiones cuya empresa aparece como “-” corresponden a usuarios que aún no han seleccionado una empresa en el panel principal."
                />

                <div>
                  <Text
                    strong
                    style={{
                      display: "block",
                      marginBottom: 4,
                      color: "#595959",
                    }}
                  >
                    Filtrar por empresa
                  </Text>
                  <SelectItem
                    width="100%"
                    allowClear
                    placeholder="Selecciona una empresa"
                    value={this.state.empresaSeleccionada}
                    onChange={this.seleccionarEmpresa}
                  >
                    {this.state.objetoEmpresas}
                  </SelectItem>
                </div>
              </div>
            </Col>
          </Row>

          <TableItemDinamico
            ref={(ref) => (this.tableRef = ref)}
            onRef={(ref) => (this.tableRef = ref)}
            totalRecords={this.state.totalRecords}
            onFetchData={this.consultarSesiones.bind(this)}
            loading={this.state.loading}
            size="small"
            dataSource={this.state.sesiones}
            columns={columns}
          />
        </div>

        <ModalCerrarSesiones
          visible={this.state.modalCerrarVisible}
          tipo={this.state.tipoCerrar}
          sessionId={this.state.sesionACerrar}
          onCancel={this.cerrarModalCerrar}
          onSuccess={this.handleCerrarSuccess}
          headersToken={this.props.headersToken}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
  };
};

export default connect(mapStateToProps)(Sesiones);
